const api = require('api');

const OPEN_SESSION_PATH = '/api/v2/librarian/reading/sessions/open';

const getCloseSessionPath = (readingSessionId) =>
  `/api/v2/librarian/reading/sessions/${encodeURIComponent(readingSessionId)}/close`;

const openReadingSession = ({
  classroomId,
  readingSessionId,
  assetId,
  title,
  openedAt,
}) =>
  api.send({
    method: 'POST',
    path: OPEN_SESSION_PATH,
    payload: {
      classroomId,
      readingSessionId,
      assetId,
      title,
      openedAt,
    },
  });

const closeReadingSession = ({
  classroomId,
  readingSessionId,
  closedAt,
}) =>
  api.send({
    method: 'POST',
    path: getCloseSessionPath(readingSessionId),
    payload: {
      classroomId,
      closedAt,
    },
  });

module.exports = {
  openReadingSession,
  closeReadingSession,
};
